export default {
  meta: {
    title: '门店经营',
    url: '/storeoperate', // 埋点字段，上报归属的模块
    urlName: '门店经营' // 埋点字段，上报归属的模块
  }
};
